import axios from 'axios';
import { AppNS } from 'app';
import { ApiNS } from 'app/api/api';
import { API_URL } from '../../core/config';

const PROTOCOLE = 'protocole_responses';

export function apiProtocoleResponses(
  id: string,
  code: string,
  properties: {
    lat: string;
    lng: string;
    localizationError: string;
    responseType: ApiNS.ProtocoleResponsesType;
    unsafeConditions: boolean;
    unsafeConditionsComment: string;
  }
): Promise<string> {
  const reqData = {
    id,
    code,
    properties,
  };
  return new Promise((resolve, reject) => {
    axios
      .patch(`${API_URL}/${PROTOCOLE}.json`, reqData)
      .then(({ data }) => {
        if (data.model) {
          resolve(data.model.id);
        } else {
          reject('Invalid response data');
        }
      })
      .catch(reject);
  });
}

export function createChecking(
  properties: {
    eventReportId: string;
    lat: string;
    lng: string;
    localizationError?: string;
    unsafeConditions?: boolean;
    unsafeConditionsComment?: string;
    type: 'check_in' | 'check_out';
  }
): Promise<AppNS.Params> {
  return new Promise((resolve, reject) => {
    axios
      .post(`${API_URL}/${PROTOCOLE}.json`, { properties })
      .then(({ data }) => {
        if (data.model) {
          resolve(data.model);
        } else {
          reject(data);
        }
      })
      .catch((error) => {
        return reject(error.response.data);
      });
  });
}

export function apiGetProtocoleResponse(
  id: string
): Promise<AppNS.ProtocoleResponse> {
  return new Promise((resolve, reject) => {
    axios
      .get(`${API_URL}/${PROTOCOLE}`, {
        params: {
          id,
        },
      })
      .then(({ data }) => {
        if (data.model) {
          resolve(data.model);
        } else {
          reject('Invalid response data');
        }
      })
      .catch(reject);
  });
}
